import React from 'react';
import { LayoutGrid, Terminal, Sparkles, Database, PaintBucket, TrendingUp, CalendarCog, Bug, MessageCircleQuestion } from 'lucide-react';

const ServicesData = [
   {
      id: 1,
      icon: <LayoutGrid size="54" strokeWidth='1' />,
      title: "Software & Product Development",
      content: "Web apps with React 19 & Next.js, mobile apps with React Native & Flutter.",
      link: "/software-product-development"
   },
   {
      id: 2,
      icon: <Terminal size="54" strokeWidth='1' />,
      title: "Python & Backend Development",
      content: "REST APIs, FastAPI, Django & backend architecture.",
      link: "/python-backend-development"
   },
   {
      id: 3,
      icon: <Sparkles size="54" strokeWidth='1' />,
      title: "AI & Intelligent Automation",
      content: "Generative AI, chatbots, AI agents & RAG.",
      link: "/ai-automation"
   },
   {
      id: 4,
      icon: <Database size="54" strokeWidth='1' />,
      title: "Database & Data Solutions",
      content: "PostgreSQL, SQL, data migration & analytics.",
      link: "/database-data-solutions"
   },
   {
      id: 5,
      icon: <PaintBucket size="54" strokeWidth='1' />,
      title: "UI/UX & Product Design",
      content: "UX research, wireframes, design systems.",
      link: "/UIUX"
   },
   {
      id: 6,
      icon: <TrendingUp size="54" strokeWidth='1' />,
      title: "Digital Marketing & SEO",
      content: "SEO, Google Ads, social & lead generation.",
      link: "/digital-marketing-seo"
   },
   {
      id: 7,
      icon: <CalendarCog size="54" strokeWidth='1' />,
      title: "CMS Solutions",
      content: "WordPress, Drupal & Magento development.",
      link: "/CMSSolutions"
   },
   {
      id: 8,
      icon: <Bug size="54" strokeWidth='1' />,
      title: "Software Testing",
      content: "Functional, regression, performance & security testing.",
      link: "/SoftwareTesting"
   },
   {
      id: 9,
      icon: <MessageCircleQuestion size="54" strokeWidth='1' />,
      title: "IT Support & Managed Services",
      content: "Monitoring, maintenance & end-to-end support.",
      link: "/ITSupportManaged"
   },
];

export default ServicesData;
